import { useState } from "react";
import "./Sidebar.css";

export default function Sidebar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* OVERLAY */}
      {open && <div className="overlay" onClick={() => setOpen(false)}></div>}

      {/* SIDEBAR */}
      <aside className={`sidebar ${open ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setOpen(false)}>❮</button>

        <h2 className="title">Menu</h2>

        <nav className="menu">
          <a className="item">🏠 Home</a>
          
        </nav>
      </aside>

      {/* BOTTONE MENU */}
      {!open && (
        <button className="menu-btn" onClick={() => setOpen(true)}>
          MENU
        </button>
      )}
    </>
  );
}
